import { useState, useRef } from "react";
import { Grid, MenuItem, FormControl, Select, Checkbox, Typography, Button, TextField, Box } from "@mui/material";
import { Formik, Form } from "formik";
import { FormDateTimePicker } from "..";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { UserUtils } from "../../utils";
import { ArrowDropDown } from "@mui/icons-material";
//--------------------------------------------------------------------------------------------------//
//--------------------------------------------------------------------------------------------------//
const plans = ["الباقة الفضية", "الباقة الذهبية", "الباقة الماسية"];
//--------------------------------------------------------------------------------------------------//
//--------------------------------------------------------------------------------------------------//
const FilterForm = ({ toggleFormModal, filter, setFilter, setQuery, setPagination, handlePageChange, type }) => {
  const user = UserUtils.getUser();
  const superAdmins = ["engr.amr.yousry@gmail.com", "ibo2001@gmail.com", "amrhammdalla2017@gmail.com"];
  const [formData, setFormData] = useState({
    //user filter form
    isAdmin: null,
    rooted: null,
    subscription: null,
    subscriptionEndDate: null,
    plan: null,
    book1: null,
    book2: null,
    watchStartDate: null,
    watchEndDate: null,
    //book filter form
    createdAt: null,
    //transactions filter form
    transStartDate: null,
    transEndDate: null,
    paymentResult: null,
  });
  const formikRef = useRef();
  //--------------------------------------------------------------------------------------------------//
  //--------------------------------------------------------------------------------------------------//
  const kickFilteration = async () => {
    if (type === "forUsersTable") {
      setQuery("");
      setPagination({ total: 0, currentPage: 0 });
      handlePageChange(0);
    }
    setFilter({ ...formData });
    toggleFormModal(false);
  };
  //--------------------------------------------------------------------------------------------------//
  //--------------------------------------------------------------------------------------------------//
  const handleChanges = (e) => {
    if (e.target.name === "isAdmin") {
      setFilter({ ...filter, [e.target.name]: e.target.checked, rooted: null });
      toggleFormModal(false);
      return;
    }
    if (e.target.name === "rooted") {
      setFilter({ ...filter, [e.target.name]: e.target.checked, isAdmin: null });
      toggleFormModal(false);
      return;
    }
    formData[e.target.name] = e.target.value ? e.target.value : "";
    setFormData({ ...formData });
  };
  //--------------------------------------------------------------------------------------------------//
  //--------------------------------------------------------------------------------------------------//
  return (
    <>
      {/* -------------------------------------------------------------------------------------- */}
      {/* -------------------------------------------------------------------------------------- */}
      <Formik
        initialValues={{
          ...formData,
        }}
        onSubmit={kickFilteration}
        innerRef={formikRef}
      >
        <Form>
          {type === "forUsersTable" && (
            <Grid container spacing={1}>
              {/* -----------------Subscription-------------------- */}
              {/* ------------------------------------------------- */}
              <Grid item xs={12}>
                <Typography variant="h6">المستخدمين</Typography>
                {superAdmins.includes(user.email) && (
                  <label>
                    الأدمن
                    <Checkbox
                      name="isAdmin"
                      inputProps={{ "aria-label": "controlled" }}
                      checked={filter.isAdmin === true ? true : false}
                      onChange={handleChanges}
                    />
                  </label>
                )}
                {superAdmins.includes(user.email) && (
                  <label>
                    روت
                    <Checkbox
                      name="rooted"
                      inputProps={{ "aria-label": "controlled" }}
                      checked={filter.rooted === true ? true : false}
                      onChange={handleChanges}
                    />
                  </label>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">الإشتراك</Typography>
                {/* -------- */}
                <label>
                  <Checkbox
                    type="checkbox"
                    name="subscription"
                    value="active"
                    checked={formData.subscription === "active"}
                    onChange={handleChanges}
                  />
                  الساري
                </label>
                {/* -------- */}
                <label>
                  <Checkbox
                    type="checkbox"
                    name="subscription"
                    value="inactive"
                    checked={formData.subscription === "inactive"}
                    onChange={handleChanges}
                  />
                  المنتهي
                </label>
                {/* -------- */}
                <label>
                  <Checkbox
                    type="checkbox"
                    name="subscription"
                    value="unsubscribed"
                    checked={formData.subscription === "unsubscribed"}
                    onChange={handleChanges}
                  />
                  غير مشترك
                </label>
                {/* -------- */}
              </Grid>
              {/* --------------------End Date--------------------- */}
              {/* ------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">تاريخ إنتهاء الإشتراك</Typography>
                {/* -------- */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <FormDateTimePicker
                      itemDate={formData.subscriptionEndDate}
                      name="subscriptionEndDate"
                      onAccept={(date) => {
                        formData.subscriptionEndDate = new Date(date.$d).getTime();
                        setFormData({ ...formData });
                      }}
                    ></FormDateTimePicker>
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              {/* ----------------------Plan----------------------- */}
              {/* ------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">الباقة</Typography>

                <Select
                  className="w-full px-2"
                  name="plan"
                  onChange={handleChanges}
                  sx={{
                    direction: "rtl", // Ensure text is right-to-left
                    "& .MuiSelect-icon": {
                      left: 4, // Move the dropdown icon to the left
                      right: "auto", // Ensure the icon is no longer aligned to the right
                    },
                  }}
                  IconComponent={ArrowDropDown} // Use the default dropdown icon
                >
                  {plans.map((plan) => (
                    <MenuItem key={plan} value={plan}>
                      {plan}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              {/* ----------------------Book----------------------- */}
              {/* ------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">جميع المستخدمين الذين استمعوا بالكامل إلى</Typography>
                <FormControl fullWidth>
                  <TextField name="book1" type="string" placeholder="اسم الكتاب" value={formData.book1} fullWidth onChange={handleChanges} />
                </FormControl>
              </Grid>
              {/* ----------------------Book----------------------- */}
              {/* ------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">جميع المستخدمين الذين استمعوا بالكامل إلى (اختباري)</Typography>
                <FormControl fullWidth>
                  <TextField name="book2" type="string" placeholder="اسم الكتاب" value={formData.book2} fullWidth onChange={handleChanges} />
                </FormControl>
              </Grid>
              {/* -------------------Watch Start Date-------------------- */}
              {/* ------------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">تاريخ بدء المشاهدة</Typography>
                {/* -------- */}
                <FormDateTimePicker
                  itemDate={formData.watchStartDate}
                  name="watchStartDate"
                  onAccept={(date) => {
                    formData.watchStartDate = new Date(date).toISOString();
                    setFormData({ ...formData });
                  }}
                ></FormDateTimePicker>
              </Grid>
              {/* --------------------Watch End Date--------------------- */}
              {/* ------------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">تاريخ نهاية المشاهدة</Typography>
                {/* -------- */}
                <FormDateTimePicker
                  itemDate={formData.watchEndDate}
                  name="watchEndDate"
                  onAccept={(date) => {
                    formData.watchEndDate = new Date(date).toISOString();
                    setFormData({ ...formData });
                  }}
                ></FormDateTimePicker>
              </Grid>
            </Grid>
          )}
          {/* ------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------- */}
          {type === "forBooksTable" && (
            <Box>
              {/* -------- */}
              <Typography variant="h6">تاريخ الإنشاء</Typography>
              {/* -------- */}
              <FormDateTimePicker
                itemDate={formData.createdAt}
                name="createdAt"
                onAccept={(date) => {
                  setFormData({
                    createdAt: new Date(date).toISOString(),
                  });
                }}
              ></FormDateTimePicker>
            </Box>
          )}
          {/* ------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------- */}
          {type === "forTransactionsTable" && (
            <Grid container spacing={2}>
              {/* ----------------------Plan----------------------- */}
              {/* ------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">الباقة</Typography>
                <FormControl fullWidth>
                  <Select
                    name="plan"
                    onChange={handleChanges}
                    sx={{
                      direction: "rtl", // Ensure text is right-to-left
                      "& .MuiSelect-icon": {
                        left: 4, // Move the dropdown icon to the left
                        right: "auto", // Ensure the icon is no longer aligned to the right
                      },
                    }}
                    IconComponent={ArrowDropDown} // Use the default dropdown icon
                  >
                    {plans.map((plan) => (
                      <MenuItem key={plan} value={plan}>
                        {plan}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {/* -------------------Trans Start Date-------------------- */}
              {/* ------------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">المعاملات ابتداً من</Typography>
                {/* -------- */}
                <FormDateTimePicker
                  itemDate={formData.transStartDate}
                  name="transStartDate"
                  onAccept={(date) => {
                    formData.transStartDate = new Date(date).toISOString();
                    setFormData({ ...formData });
                  }}
                ></FormDateTimePicker>
              </Grid>
              {/* --------------------Trans End Date--------------------- */}
              {/* ------------------------------------------------------- */}
              <Grid item xs={12}>
                {/* -------- */}
                <Typography variant="h6">المعاملات حتى</Typography>
                {/* -------- */}
                <FormDateTimePicker
                  itemDate={formData.transEndDate}
                  name="transEndDate"
                  onAccept={(date) => {
                    formData.transEndDate = new Date(date).toISOString();
                    setFormData({ ...formData });
                  }}
                ></FormDateTimePicker>
              </Grid>
              {/* -----------------Trans Status-------------------- */}
              {/* ------------------------------------------------- */}
              <Grid item xs={12}>
                <Typography variant="h6">حالة الدفع</Typography>
                {/* -------- */}
                <Box>
                  <label>
                    <Checkbox type="checkbox" name="paymentResult" value="A" checked={formData.paymentResult === "A"} onChange={handleChanges} />
                    تمت الموافقة
                  </label>
                  <label>
                    <Checkbox type="checkbox" name="paymentResult" value="P" checked={formData.paymentResult === "P"} onChange={handleChanges} />
                    قيد الإنتظار
                  </label>
                </Box>
                <Box>
                  <label>
                    <Checkbox type="checkbox" name="paymentResult" value="X" checked={formData.paymentResult === "X"} onChange={handleChanges} />
                    منهية الصلاحية
                  </label>

                  <label>
                    <Checkbox type="checkbox" name="paymentResult" value="D" checked={formData.paymentResult === "D"} onChange={handleChanges} />
                    مرفوض
                  </label>

                  <label>
                    <Checkbox type="checkbox" name="paymentResult" value="C" checked={formData.paymentResult === "C"} onChange={handleChanges} />
                    ألغيت
                  </label>
                </Box>
              </Grid>
            </Grid>
          )}
          {/* ------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------- */}
          <Button className="w-full mt-4" variant="contained" color="primary" onClick={kickFilteration}>
            بحث
          </Button>
          {/* ------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------- */}
        </Form>
      </Formik>
      {/* -------------------------------------------------------------------------------------- */}
      {/* -------------------------------------------------------------------------------------- */}
    </>
  );
};
export default FilterForm;
